import { useContext, useEffect } from 'react';
import { type PageBackground, PageLayoutContext } from './PageLayoutContext';

export const usePageBackground = (): PageBackground | undefined => {
  return useContext(PageLayoutContext)?.background;
};

export const useSetPageBackground = (background: PageBackground | undefined) => {
  const ctx = useContext(PageLayoutContext);
  useEffect(() => {
    if (!ctx) {
      return;
    }
    ctx.setBackground(background);
    return () => ctx.setBackground(undefined);
  }, [ctx, background]);
};
